var _path, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRescue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5C5.83333 2.5 2.5 5.83333 2.5 10C2.5 14.1667 5.83333 17.5 10 17.5C14.1667 17.5 17.5 14.1667 17.5 10C17.5 5.83333 14.1667 2.5 10 2.5ZM10 13.3333C8.16667 13.3333 6.66667 11.8333 6.66667 10C6.66667 8.16667 8.16667 6.66667 10 6.66667C11.8333 6.66667 13.3333 8.16667 13.3333 10C13.3333 11.8333 11.8333 13.3333 10 13.3333Z",
    fill: "#DBDBDB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    width: 5,
    height: 2,
    rx: 1,
    fill: "#6C6C6C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9,
    width: 5,
    height: 2,
    rx: 1,
    fill: "#6C6C6C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 5,
    height: 2,
    rx: 1,
    transform: "rotate(90 11 2)",
    fill: "#6C6C6C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13,
    width: 5,
    height: 2,
    rx: 1,
    transform: "rotate(90 11 13)",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRescue);
export default __webpack_public_path__ + "static/media/rescue.0dc7a3362bf446e132d00ee5504624fd.svg";
export { ForwardRef as ReactComponent };